import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 React examples
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
//import Pages from "pages/Presentation/sections/Pages";
//import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Button, Card, CardContent } from "@mui/material";
// Routes
//import routes from "routes";
// Images
import bgImage from "assets/images/strategia.jpg";
//import { ALL_MUNICIPALITIES } from "queries";
import { useQuery, useMutation } from "@apollo/client";
import { useLazyQuery } from "@apollo/client";
//import { Link } from "react-router-dom";
import {
  FIND_INITIATIVES_BY_MUNICIPALITY,
  CREATE_VOTING,
  FIND_VOTES_BY_MUNICIPALITY,
} from "queries";
import InitiativeForm from "./InitiativeForm";
import { useTranslation } from "react-i18next";
import {
  EmailShareButton,
  FacebookShareButton,
  FacebookMessengerShareButton,
  ThreadsShareButton,
  InstapaperShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  InstapaperIcon,
  LinkedinIcon,
  TelegramIcon,
  ThreadsIcon,
  //TwitterIcon,
  WhatsappIcon,
  XIcon,
} from "react-share";
//import { number } from "prop-types";
/* eslint-disable react/prop-types */

/* eslint-disable react/prop-types */
const Initiatives = ({ selectedKunta, setSelectedKunta, setError }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  //console.log(selectedKunta);
  const shareUrl = "https://kunta.live/initiatives/select/" + selectedKunta;
  const title = "Kunta.live";
  const divstyle = {
    backgroundColor: "white",
    borderRadius: 5,
    opacity: 0.9,
  };
  let muni = useParams().municipality;
  useEffect(() => {
    if (muni !== undefined) {
      setSelectedKunta(muni);
    }
  }, [muni]);
  const [t] = useTranslation("common");
  //console.log(setSelectedKunta);
  // eslint-disable-next-line
  const [getInitiatives, result] = useLazyQuery(FIND_INITIATIVES_BY_MUNICIPALITY);
  const [initiatives, setInitiatives] = useState([]);
  const [votes, setVotes] = useState([]);
  //console.log(setVotes);
  //const [ideas, setIdeas] = useState([]);
  //console.log(getInitiatives);
  //console.log(result);
  ////console.log(setOrgans);
  const initiativessw = useQuery(FIND_INITIATIVES_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });
  const votessw = useQuery(FIND_VOTES_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });
  const [createVoting] = useMutation(CREATE_VOTING, {
    refetchQueries: [
      { query: FIND_VOTES_BY_MUNICIPALITY, variables: { municipality: selectedKunta } },
    ],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment)
    }*/
  });
  useEffect(() => {
    let initiativess = [];
    //let municipalitiess = [];
    //console.log(initiativessw);
    if (initiativessw.data) {
      initiativess = initiativessw.data.findInitiativesByMunicipality;
      //console.log(initiativess);
      setInitiatives(initiativess);
    }
  }, [initiativessw, selectedKunta]);

  useEffect(() => {
    let votess = [];
    //console.log(votessw);
    if (votessw.data) {
      votess = votessw.data.findVotesByMunicipality;
      //console.log(votess);
      votess = votess.filter((a) => a.initiativeid !== null);
      if (votess.length > 0) {
        setVotes(votess.filter((a) => a.initiativeid.length > 0));
      }
    }
  }, [votessw, selectedKunta]);
  //municipalitiess=organsw.data.allOrgans
  const handleVote = (event) => {
    //console.log(event);
    const aika = Date.now();
    const pvm = new Date(aika);
    createVoting({
      variables: {
        initiativeid: event,
        userid: localStorage.getItem("id"),
        votedatetime: pvm.toString(),
        municipality: selectedKunta,
      },
    });
  };
  function voteCount(p) {
    //console.log(p);
    return votes.filter((a) => a.initiativeid === p).length;
  }
  return (
    <>
      <MKBox
        minHeight="23vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "2500px 500px",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      />
      <div
        style={{
          left: "10px",
          position: "fixed",
          top: "90px",
          bottom: 0,
          height: "20px",
          color: "#C4DFE6",
          zIndex: 99,
          backgroundColor: "white",
          borderRadius: 90,
          opacity: 0.7,
        }}
        height="20px"
      >
        <div style={divstyle}>
          <FacebookShareButton url={shareUrl} className="Demo__some-network__share-button">
            <FacebookIcon size={32} round />
          </FacebookShareButton>
        </div>
        <div style={divstyle}>
          <FacebookMessengerShareButton
            url={shareUrl}
            appId="521270401588372"
            className="Demo__some-network__share-button"
          >
            <FacebookMessengerIcon size={32} round />
          </FacebookMessengerShareButton>
        </div>
        <div style={divstyle}>
          <TwitterShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <XIcon size={32} round />
          </TwitterShareButton>
        </div>
        <div style={divstyle}>
          <TelegramShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <TelegramIcon size={32} round />
          </TelegramShareButton>
        </div>
        <div style={divstyle}>
          <WhatsappShareButton
            url={shareUrl}
            title={title}
            separator=":: "
            className="Demo__some-network__share-button"
          >
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
        </div>
        <div style={divstyle}>
          <LinkedinShareButton url={shareUrl} className="Demo__some-network__share-button">
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
        </div>
        <div style={divstyle}>
          <EmailShareButton
            url={shareUrl}
            subject={title}
            body="body"
            className="Demo__some-network__share-button"
          >
            <EmailIcon size={32} round />
          </EmailShareButton>
        </div>
        <div style={divstyle}>
          <InstapaperShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <InstapaperIcon size={32} round />
          </InstapaperShareButton>
        </div>
        <div style={divstyle}>
          <ThreadsShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <ThreadsIcon size={32} round />
          </ThreadsShareButton>
        </div>
      </div>
      <MKBox pt={0} px={1} mt={6}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="h1"
              color="dark"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              {t("initiatives.header")}
            </MKTypography>
            <MKTypography
              variant="body1"
              color="dark"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              <br />
              {t("initiatives.text")}
              <br />
              <br />
              {initiatives.map((p, index) => (
                <Card key={index} style={{ marginBottom: "0.5rem" }}>
                  <CardContent
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {p.organid}: {p.initiativetext}
                    <Button
                      variant="contained"
                      style={{ color: "white" }}
                      onClick={() => handleVote(p.id)}
                    >
                      👍 {voteCount(p.id)}
                    </Button>
                  </CardContent>
                </Card>
              ))}
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <div style={{ textAlign: "center" }}>
        <InitiativeForm
          selectedKunta={selectedKunta}
          setError={setError}
          setInitiatives={setInitiatives}
        />
      </div>
    </>
  );
};

export default Initiatives;
